<template>
  <!--==================
      component for relevant packages for blog/destination page (Vlad)
      ===============-->

  <!-- relevant package -->
  <div class="col mt-3">
    <h5 class="mb-4">
      Relevant packages <span v-if="sectionNumber != 0">for Section {{ sectionNumber + 1 }}</span>
    </h5>
    <div class="row">
      <div v-for="(p, index) in relevantPackages" :key="p.id" class="card p-0 col-md-5 mx-4">
        <img v-if="p.image" :src="p.image" class="card-img-top" />
        <img v-else src="@/assets/images/no-thumbnail-medium.jpg" class="card-img-top" />
        <div class="card-body d-flex flex-column p-3">
          <h5 class="font-weight-bold h5">{{ p.title ? p.title : "Title" }}</h5>
        </div>
        <div class="card-footer p-0 py-2">
          <div class="form-group col mt-0">
            <input
              @change="packagePreview($event, index)"
              type="number"
              class="form-control form-control-sm"
              :value="p.pId"
              placeholder="Package ID"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";
import { randStrId } from "@/assets/js/custom-function";

export default {
  name: "RelevantPackages",

  model: {
    prop: "packageIds",
    event: "idChange",
  },

  props: {
    packageIds: Array,
    sectionNumber: Number,
  },

  data() {
    return {
      relevantPackages: [],
    };
  },

  computed: {
    ...mapGetters(["tourPackage"]),
  },

  mounted() {
    this.fetchRelevantPackages();
  },

  methods: {
    ...mapActions(["fetchTourPackage"]),

    async fetchRelevantPackages() {
      var obj = {};
      obj["title"] = "";
      obj["image"] = "";
      obj["pId"] = "";
      obj["id"] = randStrId();
      this.relevantPackages.push(obj);

      for (const [index, p] of this.packageIds.entries()) {
        if (p) {
          await this.fetchTourPackage(p).then(() => {
            var obj = {};
            obj["title"] = "";
            obj["image"] = "";
            obj["pId"] = "";
            obj["id"] = randStrId();
            this.relevantPackages.push(obj);

            let noOfDays = this.tourPackage.noOfDay + "-Day ";
            let title = noOfDays + this.tourPackage.title;
            let image = this.tourPackage.image;

            this.relevantPackages[index]["title"] = title;
            this.relevantPackages[index]["image"] = image;
            this.relevantPackages[index]["pId"] = p;
          });
        }
      }
    },

    async packagePreview(event, index) {
      this.relevantPackages[index].title = "";
      this.relevantPackages[index].image = "";

      let id = $(event.target).val();

      if (id) {
        await this.fetchTourPackage(id);

        if (!this.tourPackage) {
          $.alert("Data not found for this package!");
          if (this.relevantPackages.length != index + 1) this.relevantPackages.splice(index, 1);
          else {
            this.relevantPackages[index]["pId"] = "";
          }
          this.relevantPackages.splice(this.relevantPackages.length, 1);
        } else {
          let noOfDays = this.tourPackage.noOfDay + "-Day ";
          let title = noOfDays + this.tourPackage.title;
          let image = this.tourPackage.image;

          this.relevantPackages[index].title = title;
          this.relevantPackages[index].image = image;
          this.relevantPackages[index]["pId"] = id;

          if (this.relevantPackages.length == index + 1) {
            //if last card, attend one input box
            var obj = {};
            obj["title"] = "";
            obj["image"] = "";
            obj["pId"] = "";
            obj["id"] = randStrId();
            this.relevantPackages.push(obj);
          }
        }
      } else {
        if (this.relevantPackages.length != index + 1) this.relevantPackages.splice(index, 1);
      }

      var formList = [];
      this.relevantPackages.forEach((p) => {
        if (p)
          if (p.pId != "") {
            formList.push(p.pId);
          }
      });
      this.$emit("idChange", formList);
    },
  },
};
</script>
  